var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "row" }, [
        _vm.title ? _c("h4", [_vm._v(_vm._s(_vm.title))]) : _vm._e()
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-10" }, [
          _c("div", { staticClass: "input-group mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.search,
                  expression: "search",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Buscar opción",
                "aria-label": "Buscar opción",
                "aria-describedby": "input-search"
              },
              domProps: { value: _vm.search },
              on: {
                keyup: _vm.debounceLoadOptions,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: "Agregar nueva opción",
                      expression: "'Agregar nueva opción'"
                    }
                  ],
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.addOptionNew()
                    }
                  }
                },
                [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                1
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "col-md-2 cursor-pointer" }, [
          _c(
            "span",
            {
              staticClass: "badge",
              class: {
                "badge-info": _vm.showHide,
                "badge-warning": !_vm.showHide
              },
              on: {
                click: function($event) {
                  return _vm.showHidesOptionsTogle()
                }
              }
            },
            [
              !_vm.showHide
                ? _c("feather-icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: "Mostrar opciones ocultas",
                        expression: "'Mostrar opciones ocultas'"
                      }
                    ],
                    attrs: { icon: "EyeIcon" }
                  })
                : _c("feather-icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: "Ocultar opciones ocultas",
                        expression: "'Ocultar opciones ocultas'"
                      }
                    ],
                    attrs: { icon: "EyeOffIcon" }
                  })
            ],
            1
          ),
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  return _vm.migrateOptions()
                }
              }
            },
            [
              _c("feather-icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: "Migrar Opciones visibles",
                    expression: "'Migrar Opciones visibles'"
                  }
                ],
                staticClass: "mr-1 cursor-pointer float-right ml-2",
                attrs: { icon: "SendIcon" }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.loading
              ? _c("b-spinner", {
                  key: "primary",
                  staticClass: "mr-1",
                  attrs: { variant: "primary" }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loading,
                expression: "!loading"
              }
            ],
            staticClass: "col-12",
            staticStyle: { "max-height": "80vh", overflow: "scroll" }
          },
          [
            _c(
              "ul",
              { staticClass: "list-group mt-5" },
              _vm._l(_vm.filteredOptions, function(option) {
                return _c(
                  "li",
                  {
                    key: "list-option-" + option.opcionId,
                    staticClass:
                      "list-group-item justify-content-between align-content-center",
                    class:
                      "habilitado-" +
                      option.deshabilitado +
                      " nivel-" +
                      option.nivel,
                    attrs: { id: "list-option-" + option.opcionId }
                  },
                  [
                    _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 col-12 mt-2" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "d-inline-block text-truncate w-75"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: "Orden: " + option.orden,
                                        expression: "'Orden: '+option.orden"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.copyToClipboard(option.orden)
                                      }
                                    }
                                  },
                                  [
                                    _c("b", [_vm._v("O:")]),
                                    _vm._v(" " + _vm._s(option.orden) + " ")
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: "Nivel: " + option.nivel,
                                        expression: "'Nivel: '+option.nivel"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.copyToClipboard(option.nivel)
                                      }
                                    }
                                  },
                                  [
                                    _c("b", [_vm._v("N:")]),
                                    _vm._v(" " + _vm._s(option.nivel) + " ")
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value:
                                          "Descripción: " + option.descripcion,
                                        expression:
                                          "'Descripción: '+option.descripcion"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.copyToClipboard(
                                          option.descripcion
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("b", [_vm._v("D:")]),
                                    _vm._v(
                                      " " + _vm._s(option.descripcion) + " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _c(
                              "span",
                              {
                                staticClass: "d-inline-block text-truncate w-75"
                              },
                              [
                                _c(
                                  "b",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: "Valor",
                                        expression: "'Valor'"
                                      }
                                    ]
                                  },
                                  [_vm._v(" V: ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: "Valor: " + option.valor,
                                        expression: "'Valor: '+option.valor"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.copyToClipboard(option.valor)
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(option.valor) + " ")]
                                )
                              ]
                            ),
                            _c("vs-icon", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: "Copiar id de opcion",
                                  expression: "'Copiar id de opcion'"
                                }
                              ],
                              staticClass:
                                "material-icons mr-1 cursor-pointer float-right ml-2",
                              attrs: { icon: "fingerprint" },
                              on: {
                                click: function($event) {
                                  return _vm.copyToClipboard(option.opcionId)
                                }
                              }
                            }),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: "Migrar Opción",
                                  expression: "'Migrar Opción'"
                                }
                              ],
                              staticClass:
                                "mr-1 cursor-pointer float-right ml-2",
                              attrs: { icon: "SendIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.migrateOption(option)
                                }
                              }
                            }),
                            option.deshabilitado == _vm.OPTION_STATES.ACTIVE &&
                            option.nivel === _vm.OPTION_LEVELS.GLOBAL
                              ? _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Ocultar opción para TODOS",
                                      expression: "'Ocultar opción para TODOS'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "FEB99",
                                      expression: "'FEB99'"
                                    }
                                  ],
                                  staticClass:
                                    "mr-1 cursor-pointer float-right ml-2",
                                  attrs: {
                                    icon: "AlertCircleIcon",
                                    color: "red"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteOption(option)
                                    }
                                  }
                                })
                              : _vm._e(),
                            option.deshabilitado == _vm.OPTION_STATES.ACTIVE
                              ? _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Ocultar opción para la empresa",
                                      expression:
                                        "'Ocultar opción para la empresa'"
                                    }
                                  ],
                                  staticClass:
                                    "mr-1 cursor-pointer float-right ml-2",
                                  attrs: { icon: "TrashIcon", color: "red" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteOptionCompany(option)
                                    }
                                  }
                                })
                              : _vm._e(),
                            option.deshabilitado == _vm.OPTION_STATES.INACTIVE
                              ? _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value:
                                        "Volver a mostrar la opción para TODOS",
                                      expression:
                                        "'Volver a mostrar la opción para TODOS'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "FEB99",
                                      expression: "'FEB99'"
                                    }
                                  ],
                                  staticClass:
                                    "mr-1 cursor-pointer float-right ml-2",
                                  attrs: {
                                    icon: "AlertCircleIcon",
                                    color: "red"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.activeOption(
                                        option,
                                        _vm.OPTION_LEVELS.GLOBAL
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            option.deshabilitado == _vm.OPTION_STATES.INACTIVE
                              ? _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value:
                                        "Volver a mostrar la opcion en la empresa",
                                      expression:
                                        "'Volver a mostrar la opcion en la empresa'"
                                    }
                                  ],
                                  staticClass:
                                    "mr-1 cursor-pointer float-right ml-2",
                                  attrs: { icon: "EyeIcon", color: "green" },
                                  on: {
                                    click: function($event) {
                                      return _vm.activeOption(option)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: "Copiar",
                                  expression: "'Copiar'"
                                }
                              ],
                              staticClass:
                                "mr-1 cursor-pointer float-right ml-2",
                              attrs: { icon: "CopyIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.copyToOptionNew(option)
                                }
                              }
                            }),
                            option.deshabilitado == _vm.OPTION_STATES.ACTIVE
                              ? _c("b-icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Editar",
                                      expression: "'Editar'"
                                    }
                                  ],
                                  staticClass:
                                    "mr-1 cursor-pointer float-right ml-2",
                                  attrs: { icon: "pencil" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editOption(option)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loading,
                expression: "!loading"
              }
            ],
            staticClass: "col-12 mt-5 mb-3"
          },
          [
            _c("fb-paginacion", {
              attrs: { total: _vm.pagination.pages, max: 10 },
              on: { change: _vm.handlePageChange },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c("option-edition-modal", {
        ref: "option-modal",
        attrs: {
          "value-type-config": _vm.valueTypeConfig,
          "extra-type-render": _vm.extraTypeRender
        },
        on: { saved: _vm.savedOption }
      }),
      _c("option-migration-modal", { ref: "option-migration-modal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }